import getApproveRejectStore from ".";
import { hasMorePendingImages } from "./has-more-pending-images";
import { hasPendingDescription } from "./has-pending-description";
import { hasPendingPeerDescription } from "./has-pending-peer-description";

export const handleApproveRejectCardCount = ({
  index,
  actionType,
  resolvingPendindData
}: {
  index: number;
  actionType: "image" | "description";
  resolvingPendindData: boolean;
}) => {
  const userHasPendingImages = hasMorePendingImages({ index });
  const userHasPendingDescription = hasPendingDescription({ index });
  const userHasPendingPeerDescription = hasPendingPeerDescription({ index });
  const hasMorePendingData =
    userHasPendingImages ||
    userHasPendingDescription ||
    userHasPendingPeerDescription;
  const resolvingImage = actionType === "image";
  const resolvingLastPendingImage =
    resolvingImage && !userHasPendingImages && resolvingPendindData;
  const isSelfOrPeerDescription = actionType === "description";
  const resolvingPendingSelfOrPendingDescription =
    isSelfOrPeerDescription && resolvingPendindData;
  const shouldDecreaseCount =
    resolvingLastPendingImage || resolvingPendingSelfOrPendingDescription;

  if (shouldDecreaseCount) {
    getApproveRejectStore().decreaseDashboardApprovalCount();
  }

  if (!hasMorePendingData) {
    getApproveRejectStore().approvalData.get().splice(index, 1);
  }
};
